// A widget quote's hot stamping (QuoteBuilderWidget::SubmitQuoteService) on the one column the widget prices it on
// (WidgetQuoteBuilderOrchestratorService#place_hot_stamping): that field of the visitor's choice there, undefined on
// every other column -- an extra-item column reuses its column's uuid -- and quote, and once the owner chose another
// hot stamping material (QuoteBuilderWidget::OwnerHotStampingChoice), so the sections.yml Hot stamping defaults fall
// back to their own.
export function widgetHotStampingDefault(navSection, item, field) {
  const hotStamping = window.user_quote && window.user_quote.properties && window.user_quote.properties.hot_stamping;
  if (!hotStamping || hotStamping.replaced_by_owner || !navSection || !item || item.is_item_extra) {
    return undefined;
  }
  const onThisColumn = String(hotStamping.nav_section_index) === String(navSection.index)
    && hotStamping.item_uuid === item.uuid;
  return onThisColumn ? hotStamping[field] : undefined;
}
